import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./style.css";
import { IoIosArrowBack, IoIosNotificationsOutline } from "react-icons/io";
import { RiFullscreenExitLine, RiFullscreenLine } from "react-icons/ri";
import { CiLogout } from "react-icons/ci";
import { translatePath } from "../../../utils/arabic-settings";
import useModal from "../../../hooks/useModal";
import ModalContainer from "../../Modal/ModalContainer";
import NotificationsModal from "../../Modal/NotificationsModal";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { useFetchData } from "../../../hooks/useFetchData";

function MandoubNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const [suc, setsuc] = useState("");
  const [unseens, setUnseens] = useState([]);
  const { dispatch, auth } = useAuthContext();
  const [isFullscreen, setIsFullscreen] = useState(false);
  const { modalOpen, close, open } = useModal();
  const { data } = useFetchData("mandoub/notification",[suc, modalOpen]);

  useEffect(() => {
    if (data?.notifications) {
      setUnseens(data.notifications.filter((item) => !item.isSeen));
    }
  }, [data]);

 

  const handleFullscreen = () => {
    const elem = document.documentElement;

    if (!isFullscreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
      setIsFullscreen(true);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      setIsFullscreen(false);
    }
  };
  
  const handleLogOut = async () => {
    try {
      // Dispatch the LOGOUT action to update the app state
      dispatch({ type: 'LOGOUT' });
  
      // Remove the auth data from localStorage
      localStorage.removeItem('authMandoub');
  
      console.log('Logged out successfully');
    } catch (err) {
      console.error('Error during logout:', err);
    }
  };

  const currentPath = location.pathname
    .split("/")
    .filter((segment) => segment !== "")
    .filter((item) => isNaN(item));

  const handleClick = (index) => {
    const pathTo = "/" + currentPath.slice(0, index + 1).join("/");
    navigate(pathTo);
  };

  return (
    <div className="mandoub-nav df jc-sb">
      <ModalContainer>
        {modalOpen && (
          <NotificationsModal
            modalOpen={modalOpen}
            handleClose={close}
            unseens={unseens?.length}
          />
        )}
      </ModalContainer>
      <div className="df !gap-6">
        <div id="nav-footer-heading">
          <div id="nav-footer-avatar">
            <img 
              src={auth?.user.img 
                ? process.env.REACT_APP_UPLOADS_DIR + auth?.user.img 
                : "/img/default.png"
              } 
              alt="" 
            />
          </div>
          <div id="nav-footer-titlebox">
            <div id="nav-footer-title">{auth?.user.fullName}</div>
            <span id="nav-footer-subtitle">{auth?.user.area}</span>
          </div>
          <label htmlFor="nav-footer-toggle">
            <i className="fas fa-caret-up"></i>
          </label>
        </div>
        <div className="nav-icon" onClick={open}>
          <IoIosNotificationsOutline />
          {unseens.length > 0 && (
            <div className="indicator">
              {unseens.length === 10 && <span>+9</span>}
              {unseens.length < 10 && <span>{unseens.length}</span>}
            </div>
          )}
        </div>
        <div className="nav-icon" onClick={handleFullscreen}>
          {isFullscreen ? <RiFullscreenExitLine /> : <RiFullscreenLine />}
        </div>
      </div>

      <div className="path df !gap-1">
        <IoIosArrowBack className="separator" />
        {currentPath.length > 0 ? (
          currentPath.map((segment, index) => (
            <React.Fragment key={index}>
              <span
                className={`breadcrumb-segment ${
                  index === currentPath.length - 1 ? "active-path" : ""
                }`}
                onClick={() => handleClick(index)}
              >
                {translatePath(segment)}
              </span>
              {index < currentPath.length - 1 && (
                <IoIosArrowBack className="separator" />
              )}
            </React.Fragment>
          ))
        ) : (
          <span className="breadcrumb-segment" onClick={() => navigate("/")}>
            الرئيسية
          </span>
        )}
      </div>

      <div className="df">
        <div className="nav-icon">
          <CiLogout onClick={handleLogOut} />
        </div>
      </div>
    </div>
  );
}

export default MandoubNav;